module.exports = __webpack_public_path__ + "bower_components/ngWYSIWYG/dist/images/resize.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/ngWYSIWYG/dist/images/resize.gif
 ** module id = 18
 ** module chunks = 1
 **/